export default __webpack_public_path__ + "static/media/i123vp.40447777.webp";